import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { LiaSignOutAltSolid } from "react-icons/lia";
import { MdOutlineSupportAgent } from "react-icons/md";
import { AuthContext } from "../../context/AuthProvider";

const NavbarUserSesion = () => {
  const [userData, setUserData] = useState(null);
  const { logout } = useContext(AuthContext);

  useEffect(() => {
    const storedUserData = localStorage.getItem("userSession");
    if (storedUserData) {
      const parsedData = JSON.parse(storedUserData);
      setUserData(parsedData.cliente);
    }
  }, []);

  const handleLogout = () => {
    logout();
  };

  return (
    <nav className="bg-gray-800 p-2  border-b border-slate-700 top-0 fixed z-50 w-full ">
      <div className="mx-1  md:mx-3 flex  justify-between items-center">
        <div className="text-white text-xl font-bold">
          <Link to="/" className="flex gap-2 items-center">
            <img
              src="/isologo.png"
              className="object-contain w-[150px] md:w-[185px]  "
              alt="NETMAX Logo"
            />
          </Link>
        </div>
        <div className="flex space-x-4 mr-2 items-center">
          <p className="hidden md:block text-white text-sm md:text-base font-medium">
            ¡Hola {userData?.Cliente || "Usuario"}!
          </p>

          <Link
            to="https://wa.me/5493571458075"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-300 flex items-center text-[26px] gap-2 hover:text-white "
          >
            <MdOutlineSupportAgent className="inline-block mr-2" />
          </Link>
          <Link
            to="/login"
            className="text-gray-300 flex items-center text-[26px] gap-2 hover:text-white"
            onClick={handleLogout}
          >
            <LiaSignOutAltSolid />
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default NavbarUserSesion;
